<template>
  <v-snackbar
    v-model="snackbar"
    :timeout="countdown"
    :color="color"
    top
    vertical
    persistent
    @input="getOut"
  >
    <v-layout align-center pr-4>
      <v-icon class="pr-3" dark large>mdi-alert</v-icon>
      <v-layout column>
        <div class="snack-title">
          <strong>{{ $vuetify.lang.translator('inactivity_title') }}</strong>
        </div>
        <div class="snack-content">
          <div>{{ $vuetify.lang.translator('check_inactivity_warning_1') }}</div>
          <div>{{ $vuetify.lang.translator('check_inactivity_warning_2') }}<span id="contador">{{ count }}</span></div>
        </div>
        
      </v-layout>
    </v-layout>
    
    <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          outlined
          text
          @click.stop="hasActivity"
        >
        Continuar en la página
        </v-btn>
      </template>
  </v-snackbar>
</template>
  
<script>
  export default {
    name: "CheckInactivity",

    props: {
      color: {default: 'warning'},
      timeout: {default: 7200000}, // 120 min
      countdown: {default: 30000},
    },
  
    data: () => ({
      snackbar: false,
      title: 'AVISO DE INACTIVIDAD',
      count: 0,
      inactivity: null,
      timer: null,
    }),

    mounted(){
      this.startInactivity();
      addEventListener('mousemove', this.resetInactivity);
      addEventListener('keypress', this.resetInactivity);
    },

    methods: {
      startInactivity() {
        this.inactivity = setTimeout(() => {
            this.snackbar = true;
            this.startCountdown();
          }, this.timeout)
      },
      stopInactivity() {
        clearTimeout(this.inactivity);
      },
      resetInactivity(){
        this.stopInactivity();
        this.startInactivity();
      },
      
      startCountdown() {
        this.count = this.countdown / 1000;
        this.timer = setInterval(() => {
            this.count = this.count > 0 ? this.count - 1 : 0;
          }, 1000)
      },
      stopCountdown() {
        this.snackbar = false;
        clearInterval(this.timer);
      },

      hasActivity(){
        this.stopCountdown();
        this.resetInactivity();
      },
      getOut(){
        this.stopCountdown();
        this.logout();
      },
      logout(){
        if (this.$sso && this.$sso.enabled && this.$sso.logoutURL) {
          this.$router.push('/ssologout');
        } else {
          this.$router.push('/logout');
        }
      },
    },
  };
</script>
<style>
.v-snack{
  padding: 0px !important;
}
.v-snack--active{
  pointer-events: auto !important;
}
.snack-title{
  font-size: large;
}
.snack-content{
  font-size: medium;
  margin-top: 1em;
}
</style> 
